export const VERIFY_OTP_UPDATE_CODE = 'VERIFY_OTP_UPDATE_CODE';
export const VERIFY_OTP_UPDATE_SENT_ATTEMPTS =
  'VERIFY_OTP_UPDATE_SENT_ATTEMPTS';
export const VERIFY_OTP_UPDATE_CODE_ATTEMPTS =
  'VERIFY_OTP_UPDATE_CODE_ATTEMPTS';
export const VERIFY_OTP_RESET = 'VERIFY_OTP_RESET';
